import React from 'react';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import Countdown from '../../../components/atoms/countdown';
import { COUNTDOWN_TYPES } from '../../../components/atoms/countdown/utils/timezone';

const CountdownTastic = ({ data, context }) => {
  const locale = context.locale === 'en_AU@AUD' ? 'AU' : 'NZ';
  if (!data[`show${locale}`]) return null;
  if (!data) return null;

  return (
    <Countdown
      {...data}
      type={COUNTDOWN_TYPES.independent}
      background={data?.countdownBackground}
      numberBackground={data?.countNumberBackground}
      numberOpacity={data?.countNumberOpacity}
      numberColor={data?.countNumberColor}
    />
  );
};

export default tastify({
  connect: { context: true },
  translate: true,
})(CountdownTastic);
